import { lazy, LazyExoticComponent } from 'react';

const lazyWithRetry = <P extends object>(
  componentImport: () => Promise<{ default: React.ComponentType<P> }>
): LazyExoticComponent<React.ComponentType<P>> =>
  lazy(async () => {
    try {
      return await componentImport();
    } catch (error) {
      if (error instanceof Error && error.name === 'ChunkLoadError') {
        window.location.reload();
      }
      throw error;
    }
  });

export default lazyWithRetry;